import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {MeasurementHelperService} from '../../../../../service/measurement-helper.service';
import {MapService} from '../../../../../commons/map.service';
import {BaseMeasure} from '../base_measure.component';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatSnackBar} from '@angular/material';
import {MapComponent} from '../../../map.component';
import {Location} from '@angular/common';
import {EntityHelperService} from '../../../../../service/entity-helper.service';
import { XsApplicationEventsService } from '../../../../../xs/services/events/application-events.service';
import { EpsgHelperService } from '../../../../../service/epsg-helper.service';
import { FileManagementService } from '@src/app/service/file-manager.service';

const Cesium = (<any>window).Cesium

@Component({
  selector: 'app-fly-to-line',
  templateUrl: './fly-to-line.component.html',
  styleUrls: ['./fly-to-line.component.scss']
})
export class FlyToLineComponent extends BaseMeasure implements OnInit, OnDestroy {

  points:any[] = null;

  currentGeo: any

  /*@Input()
  public runtimePolylineCallback: Function;
  private runtimePolyline: any;*/

  flyingSpeed = 10;

  protected props: ({ name: string; value: any; unit: string } | { name: string; value: string; unit: string })[] = [];
  protected propsLastTwoPoint: ({ name: string; value: any; unit: string } | { name: string; value: string; unit: string })[] = [];
  private cameraEntity: any;


  constructor(protected route: ActivatedRoute, public router: Router, snackBar:
    MatSnackBar, dialog: MatDialog, public mapComp: MapComponent, public mapService: MapService, public mappingHelper: MeasurementHelperService, 
    public entityHelper: EntityHelperService, public applicationEvents:XsApplicationEventsService, public epsgHelper: EpsgHelperService, public fileManager: FileManagementService,
    private location: Location ) {
    super(route, router, snackBar, dialog, mapComp, mapService, mappingHelper, entityHelper, applicationEvents, epsgHelper, fileManager );

  }

  ngOnInit() {
    // because of local coordinates the sequence of loading scene is changed so once scene is ready we process
    if(this.mapService.scene){
      super.onInit();
    }else {
      this.addSubscription( 'fly-sceneChange',
        this.mapService.onSceneChange('fly-to-line.component').subscribe(_ => {
          super.onInit();
        })
      );
    }
    /*this.runtimePolylineCallback = this.getLinePositions.bind(this);
    this.runtimePolyline = this.mapService.viewer.entities.add({
      name: 'runtimePolyline',
      polyline: {
        positions: new Cesium.CallbackProperty(this.runtimePolylineCallback, false),
        arcType: Cesium.ArcType.GEODESIC,
        width: 2.5,
        material: new Cesium.PolylineDashMaterialProperty({
          color: Cesium.Color.YELLOW,
          dashLength: 7.0,
          outlineColor: Cesium.Color.YELLOW
        }),

      }
    });*/
  }

  ngAfterViewInit() {
  }
/*
  nukePoints(dontRedraw?: boolean) {
    super.nukePoints(dontRedraw);
    this.stopFlying();
  }


  undoNukePoints() {
    try {
      if (this.points.length === 0) {
        super.undoNukePoints();
      } else {
        super.undoNukePoints();
        this.redrawGeo();
      }
      this.stopFlying();
    } catch (e) {
      console.log(e);
      this.redrawGeo();
    }

  }

  redrawGeo(addEntity?: boolean) {
    try{
      if (this.mapComp.flyingToLine) return;
      super.baseRedrawGeo();
      if (this.points.length > 1) {
        this.points = this.points.filter( p => p.position);
        var posis = this.points.map(p => p.position.getValue());
        this.currentGeo = this.addLine(posis, this.currentPointsIndexLineWidth, this.currentPointsIndexColor);
        this.addLineToAnnotation(this.currentPointsIndex, this.currentGeo.id);
        this.allGeo.push(this.currentGeo);
        this.errMsg = null
      } else {
        this.errMsg = 'FLY_ERR_POINT';
      }
    }catch (e) {
      console.log(e.message);
    }
  }

  addLine(posis, lineWidth, color) {
    var line = this.mapService.viewer.entities.add({
      name: 'polyLine flyToLine',
      polyline: {
        name: 'line',
        positions: posis,
        arcType: Cesium.ArcType.GEODESIC,
        width: lineWidth,
        material: new Cesium.PolylineOutlineMaterialProperty({
          color: color,
          outlineColor: color

        }),
        depthFailMaterial: new Cesium.PolylineDashMaterialProperty({
          width: 0.2,
          color: color,
          dashLength: 4.0

        }),
        perPositionHeight: !this.clampToModel, // if true then it will follow real height
        clampToGround: this.clampToModel,
        classificationType: Cesium.ClassificationType.BOTH
      }
    });
    return line;
  }

  getLinePositions() {
    if (this.draggableHandleObj) return;
    if (this.pos1 && this.pos2)
      return [this.pos1, this.pos2];
  }
*/
  /*addRuntimeLine() {
    if (this.runtimePolyline && !this.mapService.viewer.entities.contains(this.runtimePolyline)) {
      this.mapService.viewer.entities.add(this.runtimePolyline);
    }
  }*/

  /*removeRuntimeLine() {
    this.mapService.viewer.entities.remove(this.runtimePolyline);
  }*/

  ngOnDestroy() {
    try{
      super.onDestroy();
      this.mapComp.inspectorComp.currentType = 'poi';
      // this.removeRuntimeLine();
      this.mapService.viewer.trackedEntity = undefined;
    }catch (e) {
      console.log(e.message);
    }

  }

  flyMe() {
    // https://cesiumjs.org/Cesium/Apps/Sandcastle/index.html?src=Interpolation.html
    this.showHideDrawing(false);
    this.mapComp.flyingToLine = true;
    // stop canvas button working
    // this.removeRuntimeLine();
    if (this.cameraEntity) {
      this.mapService.viewer.entities.remove(this.cameraEntity);
    }
    //Set bounds of our simulation time
    var start = Cesium.JulianDate.fromDate(new Date());
    this.mapService.viewer.shouldAnimate = true; // Enable animations
    this.mapService.viewer.clock.startTime = start.clone();
    this.mapService.viewer.clock.currentTime = start.clone();
    this.mapService.viewer.clock.clockRange = Cesium.ClockRange.UNBOUNDED; //Loop at the end
    /*// this.mapService.viewer.clock.multiplier = 10;
    var ii = 1;
    setInterval( () => {
      this.mapService.viewer.clock.multiplier = ii++;
    }, 1000);*/

    var property = new Cesium.SampledPositionProperty();
    var time;
    var position;
    var i = 1;
    for (let j = 0; j < this.points.length; j++) {
      time = Cesium.JulianDate.addSeconds(start, i, new Cesium.JulianDate());
      position = new Cesium.Cartesian3(this.points[j].position._value.x, this.points[j].position._value.y, this.points[j].position._value.z);
      property.addSample(time, position);
      if (j + 1 < this.points.length) {
        i += (Cesium.Cartesian3.distance(this.points[j].position._value, this.points[j + 1].position._value) / this.annotation['flyingSpeed']);
      }
    }


//Actually create the entity
    this.cameraEntity = this.mapService.viewer.entities.add({

      //Use our computed positions
      position: property,

      //Automatically compute orientation based on position movement.
      orientation: new Cesium.VelocityOrientationProperty(property),

      billboard: {
        image: '',
        show: true
      }
    });
    this.mapService.viewer.trackedEntity = this.cameraEntity;
    // untrack entity once flied
    setTimeout(() => {
      this.stopFlying();
    }, i * 1000);
    this.mapComp.detailsNav.close();
  }

  stopFlying() {
    if (this.mapComp.flyingToLine) {
      this.mapService.viewer.trackedEntity = undefined;
      // this.showHideDrawing(true);
      this.removeDrawing();
      // this.addRuntimeLine();
      this.mapComp.flyingToLine = false;
      this.navigateBack(this.location);
    }

  }

  private showHideDrawing(b: boolean) {
   //  this.allGeo.forEach(v => v.show = b);
    this.points.forEach(v => v.show = b);
  }

  private removeDrawing() {
    // this.allGeo.forEach(v => this.mapService.viewer.entities.remove(v));
    this.points.forEach(v => this.mapService.viewer.entities.remove(v));
  }
}

